import { capitalizeString } from '@/modules/shared/utils/capitalizeString';
import type { Option } from '@/sections/shared/types/Option';

import useRegions from './useRegions';
const useRegionsOptions = (): Option[] => {
  const { data } = useRegions();

  return data.map(({ id, name }) => ({
    value: id,
    label: capitalizeString(name.trim())
  }));
};

export default useRegionsOptions;
